import { createHashRouter, RouterProvider } from 'react-router';
import { lazy, Suspense, type ReactNode } from 'react';

const AdminPortal = lazy(() => import('./pages/AdminPortal').then(module => ({ default: module.AdminPortal })));
const ArtistPortal = lazy(() => import('./pages/ArtistPortal').then(module => ({ default: module.ArtistPortal })));
const BrandPortal = lazy(() => import('./pages/BrandPortal').then(module => ({ default: module.BrandPortal })));
const LandingPage = lazy(() => import('./pages/LandingPage').then(module => ({ default: module.LandingPage })));

const page = (content: ReactNode) => (
  <Suspense fallback={<div className="app-loading"><span>420</span><strong>Workspace wird geladen …</strong></div>}>
    {content}
  </Suspense>
);

const router = createHashRouter([
  { path: '/', element: page(<LandingPage />) },
  { path: '/admin/*', element: page(<AdminPortal />) },
  { path: '/artist/*', element: page(<ArtistPortal />) },
  { path: '/brand/*', element: page(<BrandPortal />) },
]);

export function App() {
  return <RouterProvider router={router} />;
}
